import { Stack, Typography } from '@mui/material'
import { useGetProjects } from '@/service-library/hooks/projects'

export default function ProjectTotalCounts() {
  const { projects = [], isPending: projectsIsLoading } = useGetProjects({
    filters: {
      limit: '1000',
      fields__only: 'id,name,basic_states_stats',
    },
  })

  return projectsIsLoading ? null : (
    <Stack spacing={1}>
      {projects.map((project) => {
        const total = Object.values(project.basic_states_stats || {}).reduce(
          (acc, { count }) => {
            return acc + count
          },
          0,
        )
        return (
          <Stack
            direction="row"
            spacing={2}
            key={project.id}
            sx={{ minWidth: 300 }}
          >
            <Typography sx={{ flexGrow: 1 }}>{project.name}</Typography>
            <Typography>
              <b>{total}</b>
            </Typography>
          </Stack>
        )
      })}
    </Stack>
  )
}
